import React from 'react';
import { messageService } from "./eventBus";
import { NotificationContainer } from './Notification'
import WindowDispatch from '../WindowDispatch';
import AddActiveClass from './AddActiveClass';

const defaultMessage = "CTSU Default Notification";
const defaultAlign = "left";
const defaultLocation = "bottom";
const defaultDisplayTimeInSec = 6;
const defaultAutoHide = false;

function OpenNotification(props) {
  messageService.emit("open-notification", props);
}
function OpenSuccessNotification(props) {
  OpenNotification({
    type: "success",
    message: props.message || defaultMessage,
    align: props.align || defaultAlign,
    autoHide: props.autoHide !== undefined ? props.autoHide : defaultAutoHide,
    location: props.location || defaultLocation,
    displayTimeInSec: props.displayTimeInSec || defaultDisplayTimeInSec
  });
}
function OpenErrorNotification(props) {
  OpenNotification({
    type: "error",
    message: props.message || defaultMessage,
    align: props.align || defaultAlign,
    autoHide: props.autoHide !== undefined ? props.autoHide : defaultAutoHide,
    location: props.location || defaultLocation,
    displayTimeInSec: props.displayTimeInSec || defaultDisplayTimeInSec
  });
}
function OpenWarningNotification(props) {
  OpenNotification({
    type: "warning",
    message: props.message || defaultMessage,
    align: props.align || defaultAlign,
    autoHide: props.autoHide !== undefined ? props.autoHide : defaultAutoHide,
    location: props.location || defaultLocation,
    displayTimeInSec: props.displayTimeInSec || defaultDisplayTimeInSec
  });
}
// use this notification for screen readers when there are no visual notifications
// such as when row is added/deleted, reset button clicked
// do not combine with other notifications
function OpenNotifyScreenReader(props) {
  OpenNotification({
    type: "for-screen-reader",
    message: props.message || defaultMessage,
    align: props.align || defaultAlign,
    autoHide: props.autoHide !== undefined ? props.autoHide : defaultAutoHide,
    location: props.location || defaultLocation,
    displayTimeInSec: props.displayTimeInSec || 8
  });
}
function withNotificationContainer(Component) {
  return function WrappedComponent(props) {
    return (
      <>
        <NotificationContainer />
        <WindowDispatch>
          <Component {...props} />
          <AddActiveClass />
        </WindowDispatch>
      </>
    );
  };
}

export {
  NotificationContainer,
  OpenNotification,
  OpenSuccessNotification,
  OpenErrorNotification,
  OpenWarningNotification,
  withNotificationContainer,
  OpenNotifyScreenReader
}


